import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';

import SearchBox from '@root/modules/Sellers/Inquiry/components/Search';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import DropdownAction from '@root/modules/Warehouse/Shared/Actions/DropdownAction';
import { DatePicker, Menu, Table } from 'antd';
import forwardingService from '../../services';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { useState, useEffect } from 'react';

interface SellerItem {
  id: string;
  // Add other fields as needed
}

const ForwarderSeller = () => {
  const history = useHistory();
  const breadcrumbList = [
    { tittle: 'Seller', url: '' },
    { tittle: 'Seller List', url: '' }
  ];
  const [search, setSearch] = useState('');
  const [searchBy, setSearchBy] = useState('');
  const [sort, setSort] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [sellerList, setSellerList] = useState<SellerItem[]>([]);
  const fetchSellerList = async () => {
    const res = await forwardingService.getSellerList(
      currentPage,
      searchBy,
      search,
      date?.[0],
      date?.[1]
    );
    setSellerList(res.res);
    setTotal(res.count);
  };
  const [total, setTotal] = useState(0);

  const [label, setLabel] = useState({
    key: '1',
    label: 'Select'
  } as any);
  console.log(sellerList);
  const columns = [
    {
      title: 'No',
      dataIndex: 'id'
    },

    {
      title: 'Seller E-mail Address',
      dataIndex: 'seller',
      render: (seller: any) => seller.email
    },
    {
      title: 'Seller Name',
      dataIndex: 'seller',
      render: (seller: any) => seller.companyName
    },
    {
      title: 'Request a inquiry',
      dataIndex: 'hasQuotation',
      render: (hasQuotation: any) => (hasQuotation ? 'O' : 'X')
    },
    {
      title: 'Conversation Status',
      dataIndex: 'cancelStatusText'
    },
    {
      title: 'Progress Status',
      dataIndex: 'status'
    },
    {
      title: 'First Message Date',
      dataIndex: 'firstMessage',
      render: (firstMessage: any) =>
        formatDateTime(new Date(firstMessage.created_at))
    },
    {
      title: 'Last Message Date',
      dataIndex: 'lastMessage',
      render: (lastMessage: any) =>
        formatDateTime(new Date(lastMessage.created_at))
    }
  ];
  const getSelect = (e: any) => {
    setSearchBy(e.key);
    setLabel({ key: e.key, label: e.domEvent.target.innerText });
  };
  const menu = [
    {
      id: 1,
      titleSelect: 'Select',
      list: (
        <Menu
          onClick={getSelect}
          items={[
            {
              label: 'Seller Name',
              key: 'seller.name'
            },
            {
              label: 'Seller E-mail Address',
              key: 'email'
            }
          ]}
        />
      )
    }
  ];
  const [date, setDate] = useState<[string, string]>();
  useEffect(() => {
    fetchSellerList();
  }, [searchBy, search, date, currentPage]);
  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <div style={{ display: 'flex', gap: 8 }} className="control">
          <DatePicker.RangePicker
            onChange={(date: any, dateString: [string, string]) => {
              setDate(dateString);
            }}
            style={{ marginRight: 0 }}
            placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
            format={'YYYY-MM-DD'}
          />
          {menu.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={label.label}
                list={item.list}
              />
            );
          })}
          <SearchBox type onChange={(e: any) => setSearch(e.target.value)} />
        </div>
        <div className="table">
          <div>
            <div className="table__head" style={{ padding: '1rem' }}>
              <span style={{ marginLeft: 8 }}>Total Seller 00</span>
            </div>

            <Table
              // loading={loading}
              columns={columns}
              dataSource={sellerList}
              pagination={{
                total: total,
                current: currentPage,
                showSizeChanger: false,
                onChange: (page, limit) => {
                  setCurrentPage(page);
                }
              }}
              onRow={(item) => {
                return {
                  onClick: () => {
                    history.push(`/admin/forwarder/seller/${item.id}`);
                  }
                };
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForwarderSeller;
